module.exports = __webpack_public_path__ + "img/signature-info-grey.c05128e5.png";